export default {
      id: "documents-usage",
      viewBox: "0 0 93 70",
      url: "../dist/images/" + "sprite.svg#documents-usage",
      toString: function () {
        return this.url;
      }
    }